"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFacebookUrl = void 0;
var objectToUrlParams_1 = __importDefault(require("./objectToUrlParams"));
var getFacebookUrl = function (_a) {
    var url = _a.url, quote = _a.quote, suppliedHashtag = _a.hashtag;
    var hashtag = suppliedHashtag;
    if (hashtag && hashtag.charAt(0) !== "#")
        hashtag = "#" + hashtag;
    return "https://www.facebook.com/sharer/sharer.php" + objectToUrlParams_1.default({
        u: url,
        quote: quote,
        hashtag: hashtag,
    });
};
exports.getFacebookUrl = getFacebookUrl;
exports.default = exports.getFacebookUrl;
//# sourceMappingURL=getFacebookUrl.js.map